import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRemoteClientPost } from '../../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../../remote/local-storage'

export const LoadProducts = () => {
  const [params] = useSearchParams()
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const { getUnitId } = useLocalStorage()

  const { httpClientPost } = useRemoteClientPost()

  const load = () => {
    if (!loading) {
      setLoading(true)
      httpClientPost(`/produto/filtro?page=${params.get('page') || 0}&size=10`, {
        status: 1,
        unidade: {
          id: getUnitId()
        }
      })
        .then(setData)
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }

  const refresh = () => {
    load()
  }

  useEffect(() => {
    load()
  }, [params])

  return {
    data,
    refresh
  }
}
